module.exports = __webpack_public_path__ + "img/test_status_1.cf71ac58.png";